export default __webpack_public_path__ + "static/media/developer.431779b1.gif";